import "./contactus.css";
import { useEffect, useState, useContext } from "react";
import CustomAlert from "../../components/customAlert/CustomAlert";
import { LanguageContext } from "../../context/LanguageContext";

const teamMembers = [
  {
    name: "rajeshPandey",
    contact: "+91 9413963203",
    email: "rajeshpandey9079@gmail.com",
    img: "/assets/teams/harshpandey.png",
  },
  {
    name: "harshPandey",
    contact: "+91 8905046144",
    email: "harshpandey9079@gmail.com",
    img: "/assets/teams/harshpandey.png",
  },
];

const useCountUp = (end, duration) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const incrementTime = 20;
    const steps = Math.ceil(duration / incrementTime);
    const stepValue = end / steps;

    const counter = setInterval(() => {
      start += stepValue;
      if (start >= end) {
        clearInterval(counter);
        setCount(end);
      } else {
        setCount(Math.ceil(start));
      }
    }, incrementTime);

    return () => clearInterval(counter);
  }, [end, duration]);

  return count;
};

const ContactUs = () => {

  const projects = useCountUp(1143, 2500);
  const cities = useCountUp(108, 2500);
  const years = useCountUp(47, 2500);

  const { t } = useContext(LanguageContext);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    role: "homeowner",
  });

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ type: "", message: "" });

    const requestEmail = {
      name: formData.fullName,
      email: formData.email,
      mobile: formData.phone,
      message: `${formData.role} from ${formData.city}`,
      productURL: window.location.href,
      role: formData.role,
      browserInfo: {
        language: navigator.language,
        platform: navigator.platform,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
        country: {
          ip: "",
          network: "",
          version: "",
          city: formData.city,
          region: "",
          country: "",
        },
      },
    };

    try {
      const response = await fetch(
        "/api/contact/sendemail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestEmail),
        }
      );

      console.log("Response status:", response.ok, " ", response.status);

      if (response.ok) {
        const data = await response.json();
        setAlert({
          type: "success",
          message: t("alertMessages.successMessageContact"),
        });
      } else {
        setAlert({
          type: "error",
          message: t("alertMessages.errorMessageContact"),
        });
      }
    } catch (error) {
      console.error("Error sending contact email:", error);
      setAlert({
        type: "error",
        message: t("alertMessages.serverErrorContact"),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="body-contactus">
      <div className="stats-section">
        <div className="overlay">
          <h2 className="stats-title">{t("HomeClient.completedProjects")}</h2>
          <div className="stats">
            <div className="stat-card">
              <h3>{projects}+</h3>
              <p>{t("HomeClient.projects")}</p>
            </div>
            <div className="stat-card">
              <h3>{cities}+</h3>
              <p>{t("HomeClient.countries")}</p>
            </div>
            <div className="stat-card">
              <h3>{years}+</h3>
              <p>{t("HomeClient.yearsExperience")}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="form-container-contactus">
        <form className="form-card-contactus" onSubmit={handleSubmit}>
          <div className="form-header">
            <h3>
              {t("contactUsForm.talkToExpert")} {t("contactUsForm.forFree")}
            </h3>
          </div>

          {/* Show custom alert */}
          <CustomAlert
            type={alert.type}
            message={alert.message}
            onClose={() => setAlert({ type: "", message: "" })}
          />

          <div className="form-group">
            <label>{t("contactUsForm.fullName")} *</label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contactUsForm.email")} *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contactUsForm.phone")} *</label>
            <div className="phone-input">
              <span className="flag">🇮🇳</span>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+91 12345-67890"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>{t("contactUsForm.city")} *</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="Enter your city"
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contactUsForm.tellUsMessage")} *</label>
            <div className="radio-box">
              <label className="radio-item">
                <input
                  type="radio"
                  name="role"
                  value="homeowner"
                  checked={formData.role === "homeowner"}
                  onChange={handleChange}
                />
                <span className="custom-radio" />{t("contactUsForm.homeOwnerMessage")}
              </label>
              <label className="radio-item">
                <input
                  type="radio"
                  name="role"
                  value="designer"
                  checked={formData.role === "designer"}
                  onChange={handleChange}
                />
                <span className="custom-radio" />{t("contactUsForm.designerMessage")}
              </label>
            </div>
          </div>

          {loading ? (
            <button
              type="button"
              className="btn-submit-contactusform loading"
              disabled
            >
              {t("contactUsForm.sending")}
            </button>
          ) : (
            <button type="submit" className="btn-submit-contactusform">
              {t("contactUsForm.contactUsFree")}
            </button>
          )}
        </form>
      </div>

      {/* Write Code below */}
      <div className="team-container">
        <h1>{t("contactUs.ourTeam")}</h1>
        <div className="team-section">
          {teamMembers.map((member, index) => (
            <div className="team-card" key={index}>
              <div className="image-container">
                <img src={member.img} alt={member.name} />
              </div>
              <div className="team-info">
                <h3>{t("contactUs." + member.name)}</h3>
                <p className="contact">
                  <a href={`tel:${member.contact}`}>{member.contact}</a>
                </p>
                <p className="email">
                  <a href={`mailto:${member.email}`}>{member.email}</a>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
